import {
    GET_VEHICLES_REQUEST,
    GET_VEHICLES_SUCCESS,
    GET_VEHICLES_FAILURE,
    GET_VEHICLE_REQUEST,
    GET_VEHICLE_SUCCESS,
    GET_VEHICLE_FAILURE,
    SET_VEHICLES,
    GET_VEHICLE_AUDIT_REQUEST,
    GET_VEHICLE_AUDIT_SUCCESS,
    GET_VEHICLE_AUDIT_FAILURE,
    GET_VEHICLE_TICKETS_REQUEST,
    GET_VEHICLE_TICKETS_SUCCESS,
    GET_VEHICLE_TICKETS_FAILURE,
    PATCH_VEHICLE_REQUEST,
    PATCH_VEHICLE_SUCCESS,
    PATCH_VEHICLE_FAILURE,
    ASSIGN_VEHICLE_AGENT_REQUEST,
    ASSIGN_VEHICLE_AGENT_SUCCESS,
    ASSIGN_VEHICLE_AGENT_FAILURE,
    ADD_VEHICLE_COMMENT_REQUEST,
    ADD_VEHICLE_COMMENT_SUCCESS,
    ADD_VEHICLE_COMMENT_FAILURE
} from '../actions/vehicles';

const initialState = {
    vehicles: [],
    vehicle: {},
    fetching: false,
    fetchingMoreItems: false,
    total: 0,
    audits: [],
    tickets: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_VEHICLES_REQUEST: {
            const isLoadingMore = action.payload?.filters?.page > 1;
            return {
              ...state,
              fetching: !isLoadingMore,       
              fetchingMoreItems: isLoadingMore 
            };
          }
          case GET_VEHICLES_SUCCESS: {
            const isLoadingMore = action.payload.page && action.payload.page > 1;
            const updatedVehicles = isLoadingMore
              ? [...state.vehicles, ...action.payload.vehicles]
              : action.payload.vehicles;
          
            return {
              ...state,
              fetching: false,
              fetchingMoreItems: false,
              vehicles: updatedVehicles,
              total: action.payload.total
            };
          }
          
          
        
        case GET_VEHICLES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case GET_VEHICLE_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_VEHICLE_SUCCESS: {
            return {
                ...state,
                fetching: false,
                vehicle: action.payload.vehicle
            };
        }
        case GET_VEHICLE_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case GET_VEHICLE_AUDIT_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_VEHICLE_AUDIT_SUCCESS: {
            return {
                ...state,
                fetching: false,
                audits: action.payload.audits
            };
        }
        case GET_VEHICLE_AUDIT_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case GET_VEHICLE_TICKETS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_VEHICLE_TICKETS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                tickets: action.payload.tickets
            };
        }
        case GET_VEHICLE_TICKETS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case SET_VEHICLES: {
            return {
                ...state,
                vehicle: action.payload.vehicle
            }
        }
        case PATCH_VEHICLE_REQUEST:
            return { ...state, updating: true, error: null };
      
            case PATCH_VEHICLE_SUCCESS: {
                const updatedVehicle = action.payload;
                return {
                  ...state,
                  updating: false,
                  vehicles: state.vehicles.map(v =>
                    v._id === updatedVehicle._id ? { ...v, ...updatedVehicle } : v
                  ),
                  vehicle: state.vehicle && state.vehicle._id === updatedVehicle._id
                    ? { ...state.vehicle, ...updatedVehicle }
                    : state.vehicle
                };
              }
        case PATCH_VEHICLE_FAILURE:
            return { ...state, updating: false, error: action.payload };

        case ASSIGN_VEHICLE_AGENT_REQUEST:
            return { ...state, updating: true, error: null };

        case ASSIGN_VEHICLE_AGENT_SUCCESS: {
            const updatedVehicle = action.payload?.vehicle;

            return {
                ...state,
                updating: false,
                vehicle:
                    updatedVehicle && state.vehicle && state.vehicle._id === updatedVehicle._id
                        ? { ...state.vehicle, ...updatedVehicle }
                        : state.vehicle,
                vehicles:
                    updatedVehicle && Array.isArray(state.vehicles)
                        ? state.vehicles.map(v => (v._id === updatedVehicle._id ? { ...v, ...updatedVehicle } : v))
                        : state.vehicles,
            };
        }

        case ASSIGN_VEHICLE_AGENT_FAILURE:
            return { ...state, updating: false, error: action.payload?.error || action.payload };

        case ADD_VEHICLE_COMMENT_REQUEST:
            return { ...state, updating: true, error: null };

        case ADD_VEHICLE_COMMENT_SUCCESS:
            return { ...state, updating: false };

        case ADD_VEHICLE_COMMENT_FAILURE:
            return { ...state, updating: false, error: action.payload?.error || action.payload };
        default:
            return state;
    }
};
